import { ChangeEvent, useEffect, useState } from "react";
import { Card } from "primereact/card";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { Router, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  forgetPassword,
  generateOTP,
  setEmail,
  setOTPPopupOpen,
} from "src/redux/slices/bMCProfileSlice";
import { isArabic, isNullOrWhiteSpace } from "src/utils/helpers";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import { OTPType, RoutePaths } from "src/resources/enum";
import OTP from "../OTP/OTP";
import { EMAIL_REGEX } from "src/resources/constant";

const ForgetPassword = () => {
  const dispatch = useDispatch();
  const bMCProfile = useSelector((state: any) => state.bMCProfile);
  const navigate = useNavigate();

  const { t } = useTranslation(["common", "user", "registration"]);

  const [isEmailNotValid, setIsEmailNotValid] = useState(false);
  const [isSubmitButtonClicked, setIsSubmitButtonClicked] = useState(false);

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    setIsSubmitButtonClicked(true);
    if (!EMAIL_REGEX.test(bMCProfile.BMCData.email)) {
      setIsEmailNotValid(true);
      return;
    } else {
      setIsEmailNotValid(false);
    }

    dispatch(
      generateOTP(OTPType.Email, bMCProfile.BMCData.email, true) as any
    ).then((response: any) => {
      if (!response.data.OperationSucceeded) {
        isArabic()
          ? toast.error(response.data.ErrorDescriptionAr)
          : toast.error(response.data.ErrorDescriptionEn);
      } else {
        dispatch(setOTPPopupOpen(true));
      }
    });
  };

  const generateNewOTP = async (e: any) => {
    e.preventDefault();
    dispatch(generateOTP(OTPType.Email, bMCProfile.BMCData.email) as any);
  };
  const handleEmail = (e: ChangeEvent<HTMLInputElement>): void => {
    dispatch(setEmail(e.target.value));
  };
  const onSuccess = () => {
    toast.success(t("registrationSuccessMessage"));
    navigate(RoutePaths.Home);
  };
  const sendUserEmail = async (isValidOTP: boolean) => {
    if (isValidOTP) {
      dispatch(forgetPassword(onSuccess) as any);
      dispatch(setOTPPopupOpen(false) as any);
    }
  };

  useEffect(() => {
    return () => {
      dispatch(setEmail(""));
    };
  }, []);

  return (
    <>
      <div className="d-flex justify-content-center align-items-center login">
        <Card className="login-card">
          <div className="card-header d-flex mb-4 justify-content-center">
            <h1>{t("forgetPasswordTitle")}</h1>
          </div>

          <form
            className="d-flex flex-column justify-content-center"
            onSubmit={handleSubmit}
          >
            <div className="form-control">
              <label htmlFor="email">{t("email")}</label>
              <InputText
                id="email"
                name="email"
                placeholder={t("emailLabel")}
                autoComplete="false"
                type="email"
                onChange={handleEmail}
                className={`w-100 ${
                  isEmailNotValid && isSubmitButtonClicked
                    ? "invalid-input"
                    : ""
                }`}
              />
              {isEmailNotValid && isSubmitButtonClicked && (
                <p className="ms-1 error">{t("emailPatternValidation")}</p>
              )}
            </div>
            <Button
              label={t("submit")}
              className="primary-btn border-radius-100"
              disabled={isNullOrWhiteSpace(bMCProfile.BMCData.email)}
            />
          </form>
        </Card>
      </div>
      <OTP
        callbackFn={sendUserEmail}
        handleRegenerateOTP={generateNewOTP}
        otpType={OTPType.Email}
      />
    </>
  );
};

export default ForgetPassword;
